import { Input } from "@arcadeai/design-system/components/ui/atoms/input";
import { Search } from "lucide-react";
import type { KeyboardEvent } from "react";
import { useRef } from "react";
import { useToolkitPicker } from "../hooks/use-toolkit-picker";

export function SearchInput() {
  const inputRef = useRef<HTMLInputElement>(null);
  const {
    state: {
      searchQuery,
      activeTab,
      filteredToolkits,
      filteredTools,
      selectionMode,
    },
    setSearchQuery,
    toggleToolkit,
    toggleTool,
    setActiveTab,
    setToolkitFilter,
  } = useToolkitPicker();

  const selectFirstToolkit = () => {
    const firstToolkit = Array.from(filteredToolkits)[0];
    if (!firstToolkit) {
      return;
    }
    if (selectionMode === "single") {
      setToolkitFilter(firstToolkit.name);
      setActiveTab("tools");
      return;
    }
    toggleToolkit(firstToolkit);
  };

  const selectFirstTool = () => {
    const firstTool = Array.from(filteredTools)[0];
    if (!firstTool) {
      return;
    }
    toggleTool(firstTool);
  };

  const handleKeyDown = (event: KeyboardEvent<HTMLInputElement>) => {
    if (event.key !== "Enter") {
      return;
    }
    const hasQuery = searchQuery.trim().length > 0;
    if (!hasQuery) {
      return;
    }
    event.preventDefault();
    event.stopPropagation();

    if (activeTab === "toolkits") {
      selectFirstToolkit();
      return;
    }
    selectFirstTool();
  };

  return (
    <div className="relative flex-1">
      <Search className="absolute top-1/2 left-3.5 size-4 -translate-y-1/2 text-gray-400" />
      <Input
        aria-label="Search toolkits and tools"
        autoFocus
        className="h-9 pl-10"
        data-testid="search-input"
        onChange={(e) => setSearchQuery(e.target.value)}
        onKeyDown={handleKeyDown}
        placeholder="Search toolkits and tools"
        ref={inputRef}
        value={searchQuery}
      />
    </div>
  );
}
